import React from 'react';

import { IAuthUser } from '~/context/AuthContext';

interface UserAvatarProps {
  user: IAuthUser | null;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ user }) => {
  const userInitial = user?.name ? user.name.charAt(0).toUpperCase() : '';
  return (
    <div className="flex max-h-32 w-full max-w-32 items-center justify-center rounded-full bg-blue-600 p-16 text-lg leading-1 font-normal text-white">
      {userInitial ? userInitial : null}
    </div>
  );
};
